import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom";
const token = localStorage.getItem('authToken');
class EditVratSubSubCategory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            textInput: "",
            userName: "",
            title: "",
            category: '', // Initialize as empty
            categoryId: null, // Track the original category ID
            categoryChanged: false, // Track if category has been changed
            areaInput: "",
            categoryData: [],
            currentImageUrl: null,
            submissionStatus: null,
            submeet: false,
            errors: [],
            date: "",
            city: "",
            showModal: false,
            selectedCategoryId: null,
            showModalReject: false,
            selectedCategoryIdReject: null,
            maxSize: 5 * 1024 * 1024, // 5MB in bytes
        };
    }


    async componentDidMount() {
        const { match } = this.props;
        if (match && match.params && match.params.id) {
            const { id } = match.params;
            this.setState({ id });
            await this.userData(id);
        } else {
            console.error("No match params found.");
        }
        this.fetchData();
    }

    userData = async (id) => {
        try {
            const response = await axios.get(`https://samaj.aasmo.in/api/admin/vratsubsubcategory/${id}`,{
              headers: {
                Authorization: `Bearer ${token}`, 
              }
            });
            if (response) {
                console.log(response.data);
            
                this.setState({
                    userName: response.data.name,
                    category: response.data.category.name,
                    categoryId: response.data.category.id, 
                   
                    currentImageUrl: response.data.image,
                });
                
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    fetchData = async () => {
        try {
            const response = await axios.get(`https://samaj.aasmo.in/api/admin/vratsubcategory`,{
              headers: {
                Authorization: `Bearer ${token}`, 
              } 
            });
            if (response.data) {
                this.setState({ categoryData: response?.data?.Varat });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

  handleChange = (e) => {
    const files = Array.from(e.target.files);
    const errors = [];

    files.forEach((file) => {
        if (file.size > this.state.maxSize) {
            errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
        } else {
            this.setState({
                textInput: file,
                currentImageUrl: URL.createObjectURL(file), // Update current image URL to show the new image
            });
        }
    });

    this.setState({ errors });
};

handleCategoryChange = (e) => {
    this.setState({ category: e.target.value, categoryChanged: true });
};

handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ submeet: true });

    const { textInput, title, areaInput, category,userName, categoryId, categoryChanged, city, date } = this.state;
    const { id } = this.props.match.params;

    try {
        const formData = new FormData();
        formData.append('image', textInput);
        formData.append('name', userName);
     
        formData.append('category', categoryChanged ? category : categoryId);
   


        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
              
                  Authorization: `Bearer ${token}`, 
              
            },
        };


        const response = await axios.put(`https://samaj.aasmo.in/api/admin/vratsubsubcategory/${id}`, formData, config);

        if (response.status === 200) {
            this.setState({ submissionStatus: 'success', submeet: false });
            setTimeout(() => {
              this.props.history.push ("/vratAurTyoharsubsubcategory");
            }, 2000);
        }
    } catch (error) {
        console.log(error);
        this.setState({ submissionStatus: 'error' });
    }
};

render() {
    const { textInput, showModal, selectedCategoryId, isLoading,selectedCategoryIdReject, showModalReject, isDateValid, date, title, currentImageUrl, city, userName, category, categoryData, submeet, areaInput, submissionStatus } = this.state;
    const isNameValid = userName.trim().length > 0;
    const isTitleValid = title.trim().length > 0;
    const isCityValid = city?.trim().length > 0;

    if (isLoading) {
      return <div>Loading...</div>;
    }

    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Edit Vrat Aur Tyohar Sub Sub Category</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit}>

            <div className="form-group">
                                <label htmlFor="bloodGroup">Category</label>
                                <select
                                    className={`form-control ${submeet && !category && "parsley-error"}`}
                                    value={category}
                                    name="category"
                                    required=""
                                    onChange={this.handleCategoryChange}
                                >
                                    {categoryData && categoryData.map((key) => (
                                        <option key={key.id} value={key.id}>{key.name}</option>
                                    ))}
                                </select>
                                {submeet && !category ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">Category is required.</li>
                                    </ul>
                                ) : null}
                            </div>
            <div className="form-group">
                <label>Category Image</label>
               
                {currentImageUrl && (
                  <div>
                    <img src={currentImageUrl} alt="Current" style={{ width: '100px', marginBottom: '10px' }} />
                  </div>
                )}
                <input
                  type="file"
                  className={`form-control ${!textInput && submeet && "parsley-error"}`}
                  name="textInput"
                  required=""
                  onChange={this.handleChange}
                />
                {!textInput && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>Category Name</label>
                <input
                  className={`form-control ${!isNameValid && submeet && "parsley-error"}`}
                  value={userName}
                  name="userName"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ userName: e.target.value });
                  }}
                />
                {!isNameValid && submeet && (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                )}
              </div>

              {submissionStatus === "success" && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}

              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, { notifyGeneralInfo })(withRouter(EditVratSubSubCategory));
